// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5 > span[data-v-0a61e078] {\n  color: #666;\n}\n.action-button[data-v-0a61e078] {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.hint-text[data-v-0a61e078] {\n  color: #999;\n  font-size: smaller;\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
